// DEEP-LINKING ACCORDION PANES (ACCOUNTING FOR OUR NAVIGATION)
jQuery('.content-accordion').on('deeplink.zf.accordion', function(e, link, anchor) {
	if (jQuery('body').hasClass('page-template-template-locations')) {
		var scrollTop = jQuery('#locations-wrap').scrollTop();
		jQuery('#locations-wrap').stop().animate( { scrollTop: scrollTop + jQuery(link).position().top - 20 }, 1000 );
	} else {
		jQuery('html, body').stop().animate({ scrollTop: jQuery(link).offset().top - 200 }, 2000);
	}
});

jQuery(document).foundation();